<template>
    <div class="all">
      <Head></Head>
      <div class="tesegou">
        <div class="tesegou_left">
          <img src="../assets/yjdz.png" alt="">
          <div v-for="(item,key) in list" :key="key" @click="anchorJump(item.id)">
            <p>{{item.name}}</p>
          </div>
        </div>
        <div class="tesegou_right">
          <div class="tesegou_right_img">
            <img src="../assets/yizhandingzhi.png" alt="">
          </div>
          <div class="tesegou_right_for" v-for="(item,key) in list" :key="key" v-if="item.goods.length>0" :id="`ss${item.id}`">
            <div class="tesegou_right_for_title">
              {{item.name}}
            </div>
            <div class="tesegou_right_for_shop">
              <div class="tesegou_right_for_shop_for" v-for="(ite,index) in item.goods" :key="index">
                <div>
                  <img :src="ite.img" alt="">
                  <p class="tesegou_right_for_shop_for_p">{{ite.name}}</p>
                </div>
              </div>
              <div class="clear"></div>
            </div>
          </div>
          <div class="clear"></div>
        </div>
        <div class="clear"></div>
      </div>
      <div class="all_link">
        <div class="all_link_cen">
          <div class="all_link_cen_for" v-for="(item,key) in allbottom" :key="key">
            <div>{{ item.name }}</div>
            <ul>
              <li v-for="(value,key) in item.bottom_two" @click="getCliak(value.url)">{{value.name}}</li>
            </ul>
          </div>
        </div>
      </div>
      <Pagetail></Pagetail>
    </div>
</template>

<script>
  import {getinit, getntesegou} from '../api/index'
  import Pagetail from '../assembly/Pagetail'
  import Head from '../assembly/Head'
  import {getaddcollection, getquxiaocollection, getshopping} from "../api/List";
    export default {
        name: "tesegou",
      components:{
        Pagetail,Head
      },
      data(){
          return{
            list:[
              {
                id:1,
                name:'各式文件夹定制',
                goods:[
                  {
                    name:'单板夹',
                    img:require('../imges/dantanhuangjia1.png'),
                  },
                  {
                    name:'单强力夹',
                    img:require('../imges/dantanhuangjia4.png'),
                  },
                  {
                    name:'20资料册',
                    img:require('../imges/ershi.png'),
                  },
                  {
                    name:'40资料册',
                    img:require('../imges/dantanhuangjia3.png'),
                  },
                  {
                    name:'二孔文件夹',
                    img:require('../imges/shuang1.png'),
                  },
                  {
                    name:'二孔文件夹',
                    img:require('../imges/ding46.png'),
                  },
                  {
                    name:'二孔文件夹',
                    img:require('../imges/shuang3.png'),
                  },
                  {
                    name:'二孔文件夹',
                    img:require('../imges/shuang2.png'),
                  },
                  {
                    name:'三孔文件夹',
                    img:require('../imges/san1.png'),
                  },
                  {
                    name:'三孔文件夹',
                    img:require('../imges/san2.png'),
                  },
                  {
                    name:'三孔文件夹',
                    img:require('../imges/san3.png'),
                  },
                  {
                    name:'三孔文件夹',
                    img:require('../imges/san4.png'),
                  },
                  {
                    name:'四孔文件夹',
                    img:require('../imges/si2.png'),
                  },
                  {
                    name:'四孔文件夹',
                    img:require('../imges/ding47.png'),
                  },
                  {
                    name:'四孔文件夹',
                    img:require('../imges/ding48.png'),
                  },
                  {
                    name:'四孔文件夹',
                    img:require('../imges/si1.png'),
                  },
                  {
                    name:'二寸双色档案盒',
                    img:require('../imges/ding50.png'),
                  },
                  {
                    name:'二寸双色档案盒',
                    img:require('../imges/ding51.png'),
                  },
                  {
                    name:'二寸双色档案盒',
                    img:require('../imges/ding52.png'),
                  },
                  {
                    name:'二寸双色档案盒',
                    img:require('../imges/ding49.png'),
                  },
                  {
                    name:'纯色手提织布袋',
                    img:require('../imges/ding54.png'),
                  },
                  {
                    name:'纯色手提织布袋',
                    img:require('../imges/ding54.png'),
                  },
                  {
                    name:'纯色手提织布袋',
                    img:require('../imges/ding56.png'),
                  },
                  {
                    name:'纯色手提织布袋',
                    img:require('../imges/ding55.png'),
                  },
                ]
              },
              {
                id:2,
                name:'各式笔类定制',
                goods:[
                  {
                    name:'塑料圆珠笔',
                    img:require('../imges/bi1.png'),
                  },
                  {
                    name:'塑料圆珠笔',
                    img:require('../imges/bi2.png'),
                  },
                  {
                    name:'钢制圆珠笔',
                    img:require('../imges/bi3.png'),
                  },
                  {
                    name:'钢制圆珠笔',
                    img:require('../imges/bi4.png'),
                  },
                  {
                    name:'签字笔',
                    img:require('../imges/bi5.png'),
                  },
                  {
                    name:'签字笔',
                    img:require('../imges/bi6.png'),
                  },
                  {
                    name:'签字笔',
                    img:require('../imges/bi9.png'),
                  },
                  {
                    name:'签字笔',
                    img:require('../imges/bi10.png'),
                  },
                  {
                    name:'派克定制钢笔',
                    img:require('../imges/bi16.png'),
                  },
                  {
                    name:'派克定制钢笔',
                    img:require('../imges/bi17.png'),
                  },
                  {
                    name:'凌美定制钢笔',
                    img:require('../imges/bi14.png'),
                  },
                  {
                    name:'凌美定制钢笔',
                    img:require('../imges/bi15.png'),
                  },
                ]
              },
              {
                id:3,
                name:'各式办公本类定制',
                goods:[
                  {
                    name:'记事本',
                    img:require('../imges/ding57.png'),
                  },
                  {
                    name:'记事本',
                    img:require('../imges/ding58.png'),
                  },
                  {
                    name:'记事本',
                    img:require('../imges/ding59.png'),
                  },
                  {
                    name:'记事本',
                    img:require('../imges/ding60.png'),
                  },
                  {
                    name:'会议记事本',
                    img:require('../imges/ding61.png'),
                  },
                  {
                    name:'会议记事本',
                    img:require('../imges/ding62.png'),
                  },
                  {
                    name:'会议记事本',
                    img:require('../imges/ding63.png'),
                  },
                  {
                    name:'会议记事本',
                    img:require('../imges/ding64.png'),
                  },
                  {
                    name:'32开万用手册定制',
                    img:require('../imges/ding66.png'),
                  },
                  {
                    name:'万用手册定制',
                    img:require('../imges/ding65.png'),
                  },
                  {
                    name:'万用手册定制',
                    img:require('../imges/ding67.png'),
                  },
                  {
                    name:'万用手册定制',
                    img:require('../imges/ding68.png'),
                  },
                ]
              },
              {
                id:4,
                name:'纸质档案盒定制',
                goods:[
                  {
                    name:'一寸单色档案盒',
                    img:require('../imges/ding1.png'),
                  },
                  {
                    name:'一寸单色档案盒',
                    img:require('../imges/ding5.png'),
                  },
                  {
                    name:'一寸单色档案盒',
                    img:require('../imges/ding3.png'),
                  },
                  {
                    name:'一寸单色档案盒',
                    img:require('../imges/ding9.png'),
                  },
                  {
                    name:'二寸双色档案盒',
                    img:require('../imges/ding2.png'),
                  },
                  {
                    name:'二寸双色档案盒',
                    img:require('../imges/ding6.png'),
                  },
                  {
                    name:'二寸双色档案盒',
                    img:require('../imges/ding7.png'),
                  },
                  {
                    name:'二寸双色档案盒',
                    img:require('../imges/ding8.png'),
                  },
                  {
                    name:'三寸多色档案盒',
                    img:require('../imges/ding4.png'),
                  },
                  {
                    name:'三寸多色档案盒',
                    img:require('../imges/ding10.png'),
                  },
                  {
                    name:'三寸多色档案盒',
                    img:require('../imges/ding11.png'),
                  },
                  {
                    name:'三寸多色档案盒',
                    img:require('../imges/ding13.png'),
                  },
                ]
              },
              {
                id:5,
                name:'塑料档案盒定制',
                goods:[
                  {
                    name:'三寸多色档案盒',
                    img:require('../imges/ding14.png'),
                  },
                  {
                    name:'三寸双色档案盒',
                    img:require('../imges/ding15.png'),
                  },
                  {
                    name:'三寸双色档案盒',
                    img:require('../imges/ding16.png'),
                  },
                  {
                    name:'三寸单色档案盒',
                    img:require('../imges/ding17.png'),
                  },
                  {
                    name:'三寸多色档案盒',
                    img:require('../imges/ding18.png'),
                  },
                  {
                    name:'三寸双色档案盒',
                    img:require('../imges/ding19.png'),
                  },
                  {
                    name:'三寸双色档案盒',
                    img:require('../imges/ding20.png'),
                  },
                  {
                    name:'三寸单色档案盒',
                    img:require('../imges/ding21.png'),
                  },
                  {
                    name:'三寸多色档案盒',
                    img:require('../imges/ding22.png'),
                  },
                  {
                    name:'三寸双色档案盒',
                    img:require('../imges/ding23.png'),
                  },
                  {
                    name:'三寸双色档案盒',
                    img:require('../imges/ding24.png'),
                  },
                  {
                    name:'三寸单色档案盒',
                    img:require('../imges/ding25.png'),
                  },
                  {
                    name:'三寸多色档案盒',
                    img:require('../imges/ding26.png'),
                  },
                  {
                    name:'三寸双色档案盒',
                    img:require('../imges/ding27.png'),
                  },
                  {
                    name:'三寸双色档案盒',
                    img:require('../imges/ding28.png'),
                  },
                  {
                    name:'三寸单色档案盒',
                    img:require('../imges/ding29.png'),
                  },
                ]
              },
              {
                id:6,
                name:'证书定制',
                goods:[
                  {
                    name:'定制塑质荣誉证书',
                    img:require('../imges/ding30.png'),
                  },
                  {
                    name:'定制塑质会员证',
                    img:require('../imges/ding31.png'),
                  },
                  {
                    name:'定制纸质会员证',
                    img:require('../imges/ding32.png'),
                  },
                  {
                    name:'定制纸质股权证书',
                    img:require('../imges/ding33.png'),
                  },
                  {
                    name:'定制纸质劳保证书',
                    img:require('../imges/ding38.png'),
                  },
                  {
                    name:'定制纸质荣誉证书',
                    img:require('../imges/ding34.png'),
                  },
                  {
                    name:'定制纸质证书',
                    img:require('../imges/ding35.png'),
                  },
                  {
                    name:'32开荣誉证书',
                    img:require('../imges/ding36.png'),
                  },
                  {
                    name:'25开资质证书',
                    img:require('../imges/ding36.png'),
                  },
                  {
                    name:'定制纸质劳保证书',
                    img:require('../imges/ding39.png'),
                  },
                  {
                    name:'定制各类优秀纸质证书',
                    img:require('../imges/ding40.png'),
                  },
                  {
                    name:'定制荣誉证书',
                    img:require('../imges/ding41.png'),
                  },
                  {
                    name:'16开定制证书',
                    img:require('../imges/ding42.png'),
                  },
                  {
                    name:'定制奖励证书',
                    img:require('../imges/ding43.png'),
                  },
                  {
                    name:'定制各种荣誉证书',
                    img:require('../imges/ding44.png'),
                  },
                  {
                    name:'定制职业资格证',
                    img:require('../imges/ding45.png'),
                  },
                ]
              },
            ],
            allbottom:[]
          }
      },
      mounted() {
          this.init()
        window.addEventListener("scroll", this.handleScroll);
      },
      methods:{
        getCliak(url){
          // console.log(url)
          window.open(url)
        },
        init() {
          getinit().then(res => {
            this.allbottom = res.bottom;
          });
        },
        getxiangqing(id){
          console.log(id)
          this.$router.push({path:'/details',query:{id:id,status:2}})
        },
        getShoping(id){
          if (this.$store.state.user.token){
            getshopping({
              goods_id:id,
              num:1
            }).then(res=>{

            })
          }else {
            this.$message('请登录');
          }
        },
        getShoucang(e){
          if (this.$store.state.user.token){
            if (e == 0){
              //  Foc/add_collection  添加收藏,goods_id,status
              getaddcollection({
                goods_id:this.$route.query.id,//
                status:this.$route.query.status,//
              }).then(res=>{
                this.init()
              })
            }else {
              // quxiao_collection 取消收藏, goods_id,status
              getquxiaocollection({
                goods_id:this.$route.query.id,//
                status:this.$route.query.status,//
              }).then(res=>{
                this.init()
              })
            }
          }else {
            this.$message('请登录');
          }

        },
        anchorJump(id) {
          document.querySelector("#ss" + id).scrollIntoView(true);
        },
        handleScroll() {
          var scrollTop =
            window.pageYOffset ||
            document.documentElement.scrollTop ||
            document.body.scrollTop;
          if (scrollTop > 340) {
            this.searchBarFixed = true;
          } else {
            this.searchBarFixed = false;
          }
        },
      }
    }
</script>

<style scoped lang="less">
  @import "css/tesegou1";
</style>



// WEBPACK FOOTER //
// src/components/tesegou1.vue